import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import personReducer from "./personSlice";
import personLegalReducer from "./person/personLegalSlice";
import personDirectionReducer from "./personDirectionSlice";
import personDocumentReducer from "./personDocumentSlice";
import personContactReducer from "./personContactSlice";
import personBondingReducer from "./personBondingSlice";
import personRepresentativeReducer from "./person/personRepresentativeSlice";
import memberSearchReducer from "./memberSearchSlice";
import ubigeoSearchReducer from "./ubigeoSearchSlice";
import directionSearchReducer from "./directionSearchSlice";
import personSearchReducer from "./personSearchSlice";
import memberReducer from "./memberSlice";
import memberAllergyReducer from "./memberAllergySlice";
import memberAuthorizedPersonReducer from "./memberAuthorizedPersonSlice";
import therapyReducer from "./therapySlice";
import therapyScheduleReducer from "./therapyScheduleSlice";
import therapyTherapistReducer from "./therapyTherapistSlice";
import therapyMemberReducer from "./therapyMemberSlice";
import therapySearchReducer from "./therapySearchSlice";
import invoiceItemSearchReducer from "./invoiceItemSearchSlice";
import therapyPeriodSearchReducer from "./therapyPeriodSearchSlice";
import periodSearchReducer from "./periodSearchSlice";
import periodReducer from "./periodSlice";
import filialSearchReducer from "./filialSearchSlice";
import filialReducer from "./filialSlice";
import therapyPeriodOpenReducer from "./therapyPeriodOpenSlice";
import sessionTherapistSearchReducer from "./sessionTherapistSearchSlice";
import sessionReducer from "./sessionSlice";
import sessionTherapistReducer from "./sessionTherapistSlice";
import sessionSearchReducer from "./sessionSearchSlice";
import sesionTerapeutaSearchReducer from "./sesionTerapeutaSearchSlice";
import planillaSearchReducer from "./planillaSearchSlice";
import invoiceItemReducer from "./invoiceItemSlice";
import sessionCriterionReducer from "./sessionCriterionSlice";
import therapyPlanSearchReducer from "./therapyPlanSearchSlice";
import therapyPlanTherapistSearchReducer from "./therapyPlanTherapistSearchSlice";
import therapyPlanReducer from "./therapyPlanSlice";
import therapyPlanAreaReducer from "./therapyPlanAreaSlice";
import therapyPlanObjetivoReducer from "./therapyPlanObjetivoSlice";
import personPastReducer from "./personPastSlice";
import memberLanguageLevelReducer from "./memberLanguageLevelSlice";
import modelSearchReducer from "./modelSearchSlice";
import areaReducer from "./areaSlice";
import areaObjectiveReducer from "./areaObjectiveSlice";
import areaObjectiveCriterionReducer from "./areaObjectiveCriterionSlice";
import skillReducer from "./skillSlice";
import receiptReducer from "./receiptSlice";
import receiptDetailReducer from "./receiptDetailSlice";
import receiptPaymentReducer from "./receiptPaymentSlice";
import receiptSearchReducer from "./receiptSearchSlice";
import catalogReducer from "./catalogSlice";
import catalogSearchReducer from "./catalogSearchSlice";
import trabajadorReducer from "./trabajadorSlice";
import trabajadorSearchReducer from "./trabajadorSearchSlice";
import seguridadReducer from "./seguridadSlice";
import puntuacionReducer from "./puntuacionSlice";
import puntuacionDetalleReducer from "./puntuacionDetalleSlice";
import puntuacionGrupoReducer from "./puntuacionGrupoSlice";
import puntuacionSearchReducer from "./puntuacionSearchSlice";
import configuracionReducer from "./configuracionSlice";
import evaluacionReducer from "./evaluacionSlice";
import evaluacionDetalleReducer from "./evaluacionDetalleSlice";
import objetivoCatalogoReducer from "./objetivoCatalogoSlice";
import participanteObjetivoReducer from "./participanteObjetivoSlice";
import evaluacionSearchReducer from "./evaluacionSearchSlice";

export const store = configureStore({
  reducer: {
    person: personReducer,
    personLegal: personLegalReducer,
    personDirection: personDirectionReducer,
    personDocument: personDocumentReducer,
    personContact: personContactReducer,
    personBonding: personBondingReducer,
    personRepresentative: personRepresentativeReducer,
    user: userReducer,
    ubigeoSearch: ubigeoSearchReducer,
    directionSearch: directionSearchReducer,
    personSearch: personSearchReducer,
    memberSearch: memberSearchReducer,
    member: memberReducer,
    memberAllergy: memberAllergyReducer,
    memberAuthorizedPerson: memberAuthorizedPersonReducer,
    therapy: therapyReducer,
    therapySchedule: therapyScheduleReducer,
    therapyTherapist: therapyTherapistReducer,
    therapyMember: therapyMemberReducer,
    therapySearch: therapySearchReducer,
    invoiceItemSearch: invoiceItemSearchReducer,
    therapyPeriodSearch: therapyPeriodSearchReducer,
    periodSearch: periodSearchReducer,
    period: periodReducer,
    filialSearch: filialSearchReducer,
    filial: filialReducer,
    therapyPeriodOpen: therapyPeriodOpenReducer,
    sessionTherapistSearch: sessionTherapistSearchReducer,
    session: sessionReducer,
    sessionTherapist: sessionTherapistReducer,
    sessionSearch: sessionSearchReducer,
    sesionTerapeutaSearch: sesionTerapeutaSearchReducer,
    planillaSearch: planillaSearchReducer,
    invoiceItem: invoiceItemReducer,
    sessionCriterion: sessionCriterionReducer,
    therapyPlanSearch: therapyPlanSearchReducer,
    therapyPlanTherapistSearch: therapyPlanTherapistSearchReducer,
    therapyPlan: therapyPlanReducer,
    therapyPlanArea: therapyPlanAreaReducer,
    therapyPlanObjetivo: therapyPlanObjetivoReducer,
    personPast: personPastReducer,
    memberLanguageLevel: memberLanguageLevelReducer,
    modelSearch: modelSearchReducer,
    area: areaReducer,
    areaObjective: areaObjectiveReducer,
    areaObjectiveCriterion: areaObjectiveCriterionReducer,
    skill: skillReducer,
    receipt: receiptReducer,
    receiptDetail: receiptDetailReducer,
    receiptPayment: receiptPaymentReducer,
    receiptSearch: receiptSearchReducer,
    catalog: catalogReducer,
    catalogSearch: catalogSearchReducer,
    trabajador: trabajadorReducer,
    trabajadorSearch: trabajadorSearchReducer,
    seguridad: seguridadReducer,
    puntuacion: puntuacionReducer,
    puntuacionDetalle: puntuacionDetalleReducer,
    puntuacionGrupo: puntuacionGrupoReducer,
    puntuacionSearch: puntuacionSearchReducer,
    configuracion: configuracionReducer,
    evaluacion: evaluacionReducer,
    evaluacionDetalle: evaluacionDetalleReducer,
    objetivoCatalogo: objetivoCatalogoReducer,
    participanteObjetivo: participanteObjetivoReducer,
    evaluacionSearch: evaluacionSearchReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});
